import { useContext } from 'react';
import AuthContext from '../../contexts/AuthContext';

// Real tax questions, not fragments: one per kind of task (criterio del SII, cambio legal, TTA, operación).
export const EXAMPLE_QUESTIONS = [
  '¿Los gastos de vehículos de una SpA Pro-Pyme son deducibles?',
  '¿Qué cambió con la Ley 21.210 para el régimen 14D?',
  '¿Qué ha resuelto el TTA sobre gastos no acreditados del artículo 31?',
  '¿Cómo tributa un retiro de utilidades en 14D N°3?',
];

/** «Buenos días» hasta las 12, «Buenas tardes» hasta las 20 y «Buenas noches» después, con el nombre de pila si lo hay. */
export function saludo(hora: number, nombre?: string | null): string {
  const base = hora >= 5 && hora < 12 ? 'Buenos días' : hora >= 12 && hora < 20 ? 'Buenas tardes' : 'Buenas noches';
  const pila = nombre?.trim().split(/\s+/)[0];
  return pila ? `${base}, ${pila}` : base;
}

interface ChatEmptyStateProps {
  /** Llena la caja con la pregunta; no la envía (DESIGN.md §12). */
  onSuggestionClick: (question: string) => void;
}

/**
 * Vista vacía del chat, B1 «Lista limpia» (DESIGN.md §12): saludo y cuatro preguntas de ejemplo en texto, alineados con la
 * caja de consulta que queda debajo, en el mismo lugar que durante la conversación.
 */
export default function ChatEmptyState({ onSuggestionClick }: ChatEmptyStateProps) {
  // Sin AuthProvider (tests) no hay nombre: queda solo el saludo.
  const nombre = useContext(AuthContext)?.profile?.name;

  return (
    <div className="px-4 pb-6">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-[22px] leading-[1.25] font-semibold tracking-[-0.015em] text-slate-900 mb-3.5">
          {saludo(new Date().getHours(), nombre)}
        </h2>
        <ul className="-mx-2.5">
          {EXAMPLE_QUESTIONS.map((question) => (
            <li key={question}>
              <button
                type="button"
                onClick={() => onSuggestionClick(question)}
                className="block w-full text-left px-2.5 py-2 rounded-lg text-sm text-slate-500 hover:bg-slate-50 hover:text-slate-900 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                {/* Guion que no corta (U+2011): «Pro-Pyme» no se parte entre líneas; la pregunta que llena la caja conserva el normal */}
                {question.replace(/-/g, '‑')}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
